import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Committees from "@/pages/Committees";
import Certificate from "@/pages/Certificate";
import AdminDashboard from "@/pages/AdminDashboard";
import LegalStanding from "@/pages/LegalStanding";
import CERDObligations from "@/pages/CERDObligations";
import TheBlackCensus from "@/pages/TheBlackCensus";
import TheNation from "@/pages/TheNation";
import PoliticalEngagement from "@/pages/PoliticalEngagement";
import Library from "@/pages/Library";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/legal-standing" element={<LegalStanding />} />
            <Route path="/cerd-obligations" element={<CERDObligations />} />
            <Route path="/census" element={<TheBlackCensus />} />
            <Route path="/the-nation" element={<TheNation />} />
            <Route path="/political-engagement" element={<PoliticalEngagement />} />
            <Route path="/library" element={<Library />} />
            <Route path="/committees" element={<ProtectedRoute><Committees /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/certificate" element={<ProtectedRoute><Certificate /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
